// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button_icon-button__MuuY-"};